export default "/images/c6a0cff0b9c6e2920bf6bae79d5c8305.avif";